export class ReportFlag {

    public get reportFlags() {
        return this.flags;
    }

    private flags: { [indexedDd: string]: string };

    constructor(flags: { [indexedDb: string]: string }) {
        this.flags = flags;
    }

    public toString() {
        return this.flags ? Object.keys(this.flags).map(flag => flag.toUpperCase()).join(' ') : '';
    }
}